export default __webpack_public_path__ + "static/media/PH-B695.de413a7a.webp";